import * as React from 'react'
const SvgVideoCallIcon = (props) => (
  <svg
    width="56"
    height="57"
    viewBox="0 0 56 57"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="4" y="4.5" width="48" height="48" rx="24" fill="#D1FADF" />
    <path
      d="M30.0497 22.5C31.0264 22.6906 31.924 23.1683 32.6277 23.8719C33.3314 24.5756 33.8091 25.4733 33.9997 26.45M30.0497 18.5C32.0789 18.7254 33.9713 19.6342 35.4159 21.077C36.8606 22.5198 37.7717 24.411 37.9997 26.44M26.2266 30.3631C25.0251 29.1615 24.0763 27.8028 23.3803 26.3532C23.3204 26.2285 23.2905 26.1662 23.2675 26.0873C23.1858 25.8069 23.2445 25.4627 23.4145 25.2253C23.4623 25.1584 23.5195 25.1013 23.6338 24.987C23.9834 24.6374 24.1582 24.4626 24.2725 24.2868C24.7035 23.6239 24.7035 22.7693 24.2725 22.1064C24.1582 21.9307 23.9834 21.7559 23.6338 21.4062L23.4389 21.2114C22.9075 20.6799 22.6417 20.4142 22.3564 20.2699C21.7888 19.9828 21.1185 19.9828 20.551 20.2699C20.2656 20.4142 19.9999 20.6799 19.4684 21.2114L19.3108 21.369C18.7812 21.8986 18.5164 22.1634 18.3141 22.5235C18.0897 22.923 17.9283 23.5435 17.9297 24.0017C17.9309 24.4146 18.011 24.6969 18.1712 25.2613C19.0322 28.2947 20.6567 31.1571 23.0447 33.545C25.4326 35.933 28.295 37.5575 31.3284 38.4185C31.8928 38.5787 32.1751 38.6588 32.588 38.66C33.0462 38.6614 33.6667 38.5 34.0662 38.2756C34.4263 38.0733 34.6911 37.8085 35.2207 37.2789L35.3783 37.1213C35.9098 36.5898 36.1755 36.3241 36.3198 36.0387C36.6069 35.4712 36.6069 34.8009 36.3198 34.2333C36.1755 33.948 35.9098 33.6822 35.3783 33.1508L35.1835 32.9559C34.8339 32.6063 34.6591 32.4315 34.4833 32.3172C33.8204 31.8862 32.9658 31.8862 32.3029 32.3172C32.1271 32.4315 31.9523 32.6063 31.6027 32.9559C31.4884 33.0702 31.4313 33.1274 31.3644 33.1752C31.127 33.3453 30.7828 33.404 30.5024 33.3222C30.4235 33.2992 30.3612 33.2693 30.2365 33.2094C28.7869 32.5134 27.4282 31.5646 26.2266 30.3631Z"
      stroke="#039855"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="4"
      y="4.5"
      width="48"
      height="48"
      rx="24"
      stroke="#ECFDF3"
      strokeWidth="8"
    />
  </svg>
)
export default SvgVideoCallIcon
